import React from 'react';
import { getPointColor } from '../helpers/getPointColor';
import {
	Circle,
	ConsultantViewWrapper,
	EmailWrapper,
	FullName,
	GroupWrapper,
	Line,
	Point,
	RowWrapper,
	UserInfoWrapper,
} from '../consultantInfo.styles';
import { Colors } from 'chart.js';
import Icon from '@/common/components/Icon';

const WorkingUsers = ({ data, setShow }) => {
	return (
		<ConsultantViewWrapper>
			{data
				.sort((a, b) => a.name.localeCompare(b.name))
				.map(({ name, value }) => (
					<GroupWrapper>
						<Line>{name}</Line>
						<ConsultantViewWrapper>
							{value.map((d) => (
								<RowWrapper>
									<Circle isMnager={d.role === 'CALL_CENTER_MANAGER'}>
										<Icon
											name='user'
											style={{ color: Colors.darkBlue }}
										/>
									</Circle>
									<UserInfoWrapper>
										<FullName>
											{d.name} {d.surname}
											<Point color={getPointColor(d.last_ping)} />
										</FullName>
										<EmailWrapper>{d.email}</EmailWrapper>
									</UserInfoWrapper>
									{d.bound_order_contact ? (
										<Icon
											name='phone'
											style={{ color: 'green', cursor: 'pointer' }}
											onClick={() => setShow(() => d.bound_order_contact)}
										/>
									) : (
										<Icon name='phone-slash' style={{ color: 'red' }} size={25} />
									)}
								</RowWrapper>
							))}
						</ConsultantViewWrapper>
					</GroupWrapper>
				))}
		</ConsultantViewWrapper>
	);
};

export default WorkingUsers;
